<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';

	let {
		dots,
		current,
		dataCy,
		variant = 'dark',
		onDotClick = undefined,
		...rest
	}: Props = $props();

	interface Props {
		dots: number;
		current: number;
		dataCy: string;
		variant?: 'light' | 'dark';
		onDotClick?: ((index: number) => void) | undefined;
		class?: string;
	}

	let dataCyPrefix = $derived(`${dataCy}-dots`);
	let selectedDotColor = $derived(variant === 'light' ? 'bg-gray-0' : 'bg-gray-900');
</script>

{#if dots > 0}
	<div
		data-cy={dataCyPrefix}
		class={twMerge('flex flex-wrap gap-2 justify-center items-center max-w-full', rest.class)}
	>
		<!-- eslint-disable-next-line @typescript-eslint/no-unused-vars -->
		{#each Array(dots).fill(null) as _, index}
			<button
				data-cy={`${dataCyPrefix}-dot`}
				aria-label="Select dot"
				class={classNames(
					'h-3 w-3 rounded-full',
					current === index ? selectedDotColor : `${selectedDotColor} opacity-20`
				)}
				onclick={() => {
					if (onDotClick) {
						onDotClick(index);
					}
				}}
			></button>
		{/each}
	</div>
{/if}
